import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Theme,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import {
  CustomMenu,
  CustomMenuItem,
  StyledTableRow,
} from "../../../styles/Shipmentstyles";
import AppTableHeaderCell from "../common/pages/AppTableHeaderCell";
import AppTableRowCell from "../common/pages/AppTableRowCell";
import { SortType } from "../../../../src/models/SortType";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Link, useNavigate } from "react-router-dom";
import { Address } from "../../../models/Address/Address";

interface TableProps {
  //   checkbox: boolean;
  addresses: Address[];
  maxHeight?: number;
  minHeight?: number;
  limit: number;
  page_no: number;
  total_pages: number;
  total_count: number;
  sortBy?: string;
  sortType?: SortType;
  selectedShipmentIdsMap?: Map<number, number>;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => void;
  onRowsPerPageChange: (limit: number) => void;
  onSortChange?: (column: string, sortType: SortType) => void;
  selectAllItem?: () => void;
  selectItem?: (address: any) => void;
  deSelectAllItem?: () => void;
  deSelectItem?: (address: any) => void;
  onDelete: (addressId: number) => void;
}

const AddressTable = ({
  addresses,
  maxHeight,
  page_no,
  limit,
  total_count,
  sortBy,
  sortType,
  minHeight = window.innerHeight - 320,
  onPageChange,
  onRowsPerPageChange,
  onSortChange,
  onDelete,
}: TableProps) => {
  const theme = useTheme<Theme>();
  let navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);
  const [addressId, setCurrentAddressId] = useState<number | null>(null);

  const handleMenuClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    addressId: number
  ) => {
    setAnchorEl(event.currentTarget);
    setCurrentAddressId(addressId);
  };

  const handleEdit = () => {
    if (addressId)
      navigate("/address/add-edit-address?address-id=" + addressId);
  };

  const handleDelete = () => {
    if (addressId !== null) {
      onDelete(addressId);
    }
    handleMenuClose();
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setCurrentAddressId(null);
  };
  const handleRowsChange = (value: number) => {
    onPageChange(null, 1);
    onRowsPerPageChange(value);
  };

  return (
    <div>
      <TableContainer sx={{ maxHeight: maxHeight, minHeight: minHeight }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <AppTableHeaderCell
                sx={{
                  textAlign: "start",
                  position: "sticky",
                  left: 0,
                  zIndex: 12,
                }}
                sortColumn={"id"}
                sortBy={sortBy}
                sortDirection={sortType}
                onSortChange={onSortChange}
                title="ID"
              />
              <AppTableHeaderCell title="Customer" />
              <AppTableHeaderCell title="Label" />
              <AppTableHeaderCell title="First Name" />
              <AppTableHeaderCell title="Last Name" />
              <AppTableHeaderCell title="Contact No" />
              <AppTableHeaderCell title="Address Line 1" />
              <AppTableHeaderCell title="Address Line 2" />
              <AppTableHeaderCell title="Address Line 3" />
              <AppTableHeaderCell title="Email" />
              <AppTableHeaderCell title="City" />
              <AppTableHeaderCell title="State" />
              <AppTableHeaderCell title="Country" />
              <AppTableHeaderCell title="Postal Code" />
              <AppTableHeaderCell title="GSTIN" />
              <AppTableHeaderCell title="Active" />
              <AppTableHeaderCell title="Created Date" />
              <AppTableHeaderCell title="Modified Date" />
              <AppTableHeaderCell
                sx={{
                  textAlign: "center",
                  fontSize: 12,
                  position: "sticky",
                  right: 0,
                  zIndex: 10,
                  backgroundColor: `${theme.palette.background.paper}`,
                }}
                title="Actions"
              />
            </TableRow>
          </TableHead>

          <TableBody>
            {addresses.map((address) => (
              <StyledTableRow key={address.id}>
                <TableCell
                  sx={{
                    fontSize: "12px",
                    position: "sticky",
                    left: 0,
                    zIndex: 11,
                    backgroundColor: theme.palette.background.paper, // Ensures proper background for sticky cells
                    textAlign: "start",
                  }}
                >
                  {address.id || "-"}
                </TableCell>
                <AppTableRowCell>
                  {address.customer_name || "-"}
                </AppTableRowCell>
                <AppTableRowCell>{address.label || "-"}</AppTableRowCell>
                <AppTableRowCell>{address.first_name || "-"}</AppTableRowCell>
                <AppTableRowCell>
                  {address.last_name !== null ? address.last_name : ""}
                </AppTableRowCell>
                <AppTableRowCell>{address.contact_no || "-"}</AppTableRowCell>
                <AppTableRowCell>{address.address1 || "-"}</AppTableRowCell>
                <AppTableRowCell>{address.address2 || "-"}</AppTableRowCell>
                <AppTableRowCell>{address.address3 || "-"}</AppTableRowCell>
                <AppTableRowCell>{address.email || "-"}</AppTableRowCell>
                <AppTableRowCell>{address.city_name || "-"}</AppTableRowCell>
                <AppTableRowCell>{address.state_name || "-"}</AppTableRowCell>
                <AppTableRowCell>{address.country_name || "-"}</AppTableRowCell>
                <AppTableRowCell>{address.postal_code || "-"}</AppTableRowCell>
                <AppTableRowCell>{address.gstin || "-"}</AppTableRowCell>
                <AppTableRowCell>
                  {address.is_deleted === true ? "False" : "True"}
                </AppTableRowCell>
                <AppTableRowCell>
                  {address.created_date
                    ? new Date(address.created_date).toLocaleDateString(
                        "en-GB",
                        {
                          day: "numeric",
                          month: "numeric",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                        }
                      )
                    : "-"}
                </AppTableRowCell>
                <AppTableRowCell>
                  {address.modified_date
                    ? new Date(address.modified_date).toLocaleDateString(
                        "en-GB",
                        {
                          day: "numeric",
                          month: "numeric",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                        }
                      )
                    : "-"}
                </AppTableRowCell>
                <TableCell
                  sx={{
                    textAlign: "center",
                    fontSize: 12,
                    width: "10%",
                    position: "sticky",
                    right: 0,
                    zIndex: 8,
                    backgroundColor: `${theme.palette.background.paper}`,
                  }}
                  onClick={(event) => event.stopPropagation()}
                >
                  <IconButton
                    onClick={(event) => {
                      event.stopPropagation();
                      handleMenuClick(event, Number(address.id));
                    }}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <CustomMenu
                    onClick={(event) => event.stopPropagation()}
                    anchorEl={anchorEl}
                    open={isOpen}
                    onClose={handleMenuClose}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    <CustomMenuItem onClick={() => handleEdit()}>
                      <Link
                        to={`/address/add-edit-address?address-id=${addressId}`}
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        View/Edit
                      </Link>
                    </CustomMenuItem>
                    {!address.is_active && (
                      <CustomMenuItem onClick={handleDelete}>
                        Delete
                      </CustomMenuItem>
                    )}
                  </CustomMenu>
                </TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[30, 50, 100, 150, 200]}
        component="div"
        count={total_count}
        rowsPerPage={limit}
        page={page_no - 1}
        onPageChange={(event, page_no) => onPageChange(event, page_no + 1)}
        onRowsPerPageChange={(event) =>
          handleRowsChange(parseInt(event.target.value, 10))
        }
      />
    </div>
  );
};

export default AddressTable;
